import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from '@/api/api-routes';
import {
  type DraftResponse,
  getDraftDetailFn,
} from '@/api/order/get-draft-detail-fn';

export const useGetDraftDetail = (
  id: string,
  opts?: Omit<UseQueryOptions<DraftResponse, DefaultQueryError>, 'queryKey'>
) =>
  useQuery<DraftResponse, DefaultQueryError>({
    queryKey: [apiRoutes.draft.getDraftDetail(id)],
    queryFn: () => getDraftDetailFn(id),
    ...opts,
  });
